import { SelectionModel } from "@angular/cdk/collections";
import { DatePipe } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Component, inject, OnInit, viewChild } from "@angular/core";
import { MatDatepickerInputEvent, MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from "@angular/material/datepicker";
import { MatCheckboxChange, MatCheckbox } from "@angular/material/checkbox";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import { ActivatedRoute, RouterLinkActive, RouterLink } from "@angular/router";
import Swal from "sweetalert2";
import { IOrder } from "../core/models/IOrders";
import { ISimpleListElement } from "../core/models/ISimpleListElement";
import { DataAccessService } from "../core/services/data-access.service";
import { UploadService } from "../core/services/upload-service";
import { ProceedDialog } from "../orders/orders.component";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MyLoaderComponent } from "../core/components/my-loader/my-loader.component";
import { MatCard, MatCardTitle, MatCardContent } from "@angular/material/card";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatSelect, MatOption } from "@angular/material/select";
import { FormsModule } from "@angular/forms";
import { LfSelectSearchComponent } from "../core/components/lf-select-search/lf-select-search.component";
import { MatRadioGroup, MatRadioButton } from "@angular/material/radio";

const initialSelection = [];
const allowMultiSelect = true;

export interface IGA {
  id: number;
  ga_price: number;
  ga_incoterm: string;
  currency: number;
  lead_time: number;
}

interface IItemWithLeadTime extends ISimpleListElement {
  lead_time: number;
}

@Component({
    selector: "app-orderlines",
    templateUrl: "./orderlines.component.html",
    styleUrls: ["./orderlines.component.scss"],
    providers: [DataAccessService, DatePipe],
    imports: [MatToolbar, MatToolbarRow, MatButton, RouterLinkActive, RouterLink, MatIcon, MyLoaderComponent, MatCard, MatFormField, MatLabel, MatInput, MatSelect, FormsModule, MatOption, LfSelectSearchComponent, MatCardTitle, MatCardContent, MatRadioGroup, MatRadioButton, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatSortHeader, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe]
})
export class OrderlinesComponent implements OnInit {
  dialog = inject(MatDialog);
  private dataAccess = inject(DataAccessService);
  private upload = inject(UploadService);
  private route = inject(ActivatedRoute);

  private readonly datePipe = inject(DatePipe);

  displayedColumns: string[] = [
    "select",
    "status",
    "line_no",
    "line_type",
    "released_date",
    "released_week",
    "item_no",
    "item_name",
    "ga_price",
    "ga_incoterm",
    "actual_price_for_payment",
    "incoterm_for_actual_price",
    "fy",
    "original_qty",
    "original_value",
    "original_date",
    "original_week",
    "updated_original_date",
    "updated_original_week",
    "confirmed_qty",
    "confirmed_value",
    "confirmed_date",
    "confirmed_week",
    "dispatched_qty",
    "dispatched_value",
    "dispatched_date",
    "dispatched_week",
    "unloaded_qty",
    "unloaded_value",
    "unloaded_date",
    "unloaded_week",
    "customers_comments",
    "suppliers_comments",
    "cancel_reason_code",
    "nw_cf_reason_code",
    "cf_dp_reason_code",
  ];

  readonly paginator1 = viewChild("pag1", { read: MatPaginator });
  readonly sort1 = viewChild("table1", { read: MatSort });

  dataSource: MatTableDataSource<IOrder> = new MatTableDataSource<IOrder>();
  selection = new SelectionModel<IOrder>(null, null);

  line: IOrder = {} as IOrder;
  items: IItemWithLeadTime[] = [];
  suppliers: ISimpleListElement[] = [];
  customers: ISimpleListElement[] = [];
  currencies: ISimpleListElement[] = [];
  incoterms: ISimpleListElement[] = [];
  prices: IGA[] = [];

  showLinePanel = false;

  supplierId = 0;
  customerId = 0;
  currencyId: number;

  isSupplier: boolean;
  isCustomer: boolean;
  isIkeaUser: boolean;
  isSPUser: boolean;

  id: string;
  lineId: string;
  orderNo: string;

  origPickerValue: string;
  updPickerValue: string;
  confPickerValue: string;
  minDate: Date;
  today: Date;
  workingDatesData: any[] = [];
  workingDatesForItem: any[] = [];
  disabledDatesData: any[] = [];
  disabledDates: any[] = [];

  allowEdit: boolean;

  constructor() {
    this.selection = new SelectionModel<IOrder>(
      allowMultiSelect,
      initialSelection
    );
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.today = new Date();
  }

  async ngOnInit() {
    if (await this.dataAccess.haveAccessToModuleAsync("order_lines")) {
      this.id = this.route.snapshot.paramMap.get("id");
      this.lineId = this.route.snapshot.paramMap.get("line");

      this.allowEdit = this.id == undefined || this.id == null;

      const role =
        (this.dataAccess.getLoginData() as any) &&
        (this.dataAccess.getLoginData() as any).roles
          ? (this.dataAccess.getLoginData() as any).roles.filter(
              (x) =>
                x.id == (this.dataAccess.getLoginData() as any).user_role_id
            )[0]
          : null;

      this.isSupplier = role ? role.is_supplier : false;
      this.isCustomer = role ? role.is_customer : false;
      this.isIkeaUser = !this.isSupplier && !this.isCustomer;
      this.isSPUser = (this.dataAccess.getLoginData() as any).su_roles
        ? (this.dataAccess.getLoginData() as any).su_roles.filter(
            (x) => x.role === "SP"
          ).length > 0
        : false;

      if (this.isCustomer) {
        this.customerId = (this.dataAccess.getLoginData() as any).roles.filter(
          (x) => x.id == (this.dataAccess.getLoginData() as any).user_role_id
        )[0].factory_id;
      }

      if (this.isSupplier) {
        this.supplierId = (this.dataAccess.getLoginData() as any).roles.filter(
          (x) => x.id == (this.dataAccess.getLoginData() as any).user_role_id
        )[0].factory_id;
      }

      this.dataAccess
        .getJSONPost(
          "get_factories_simple_list",
          [],
          [
            { k: "p_is_supplier", v: "1" },
            { k: "p_module", v: "orderlines" },
            { k: "p_order_id", v: this.id },
          ]
        )
        .then((data) => {
          this.suppliers = Array.isArray(data) ? data : [];
        });

      this.dataAccess
        .getJSONPost(
          "get_factories_simple_list",
          [],
          [
            { k: "p_is_customer", v: "1" },
            { k: "p_module", v: "orderlines" },
            { k: "p_order_id", v: this.id },
          ]
        )
        .then((data) => {
          this.customers = Array.isArray(data) ? data : [];
        });

      //this.getItemsList();

      this.dataAccess
        .getJSONPost(
          "get_currencies_simple_list",
          [],
          [
            { k: "p_module", v: "orderlines" },
            { k: "p_order_id", v: this.id },
          ]
        )
        .then((data) => {
          this.currencies = Array.isArray(data) ? data : [];
        });

      this.dataAccess.getJSON("get_incoterms", [], []).then((data) => {
        this.incoterms = Array.isArray(data) ? data : [];
      });

      this.dataAccess
        .getJSONPost(
          "get_disabled_dates",
          [],
          [{ k: "p_supplier_id", v: this.supplierId }]
        )
        .then((data) => {
          this.disabledDatesData = Array.isArray(data) ? data : [];
          this.disabledDates = this.disabledDatesData
            .reduce(
              (result, work_day) => {
                result[work_day.date] = work_day.date;
                return result;
              },
              {}
            )
          ;
        });

      this.refreshList();
    } else {
      this.dataAccess.logout();
    }
  }

  refreshList(): void {
    this.selection.clear();

    this.dataSource.sort = this.sort1();
    this.dataSource.paginator = this.paginator1();
    this.dataSource.sortingDataAccessor = (data, sortHeaderId) =>
      data[sortHeaderId]
        ? typeof data[sortHeaderId] === "string"
          ? data[sortHeaderId].toString().toLocaleLowerCase()
          : data[sortHeaderId]
        : null;

    if (this.id) {
      this.dataAccess
        .getJSONPost("get_orders", [], [{ k: "p_order_id", v: this.id }])
        .then((data) => {
          this.dataSource.data = Array.isArray(data) ? data : [];

          this.orderNo = data[0].order_no;
          this.supplierId = data[0].supplier_id;
          this.customerId = data[0].customer_id;
          this.currencyId = data[0].currency_id;

          this.getItemsList();
          this.getWorkingDates();
        })
        .then(() => {
          if (this.lineId) {
            this.openEditDialog(
              this.dataSource.data.filter(
                (x) => x.line_id == parseInt(this.lineId)
              )[0]
            );
            this.lineId = null;
          }
        });
    } else {
      this.orderNo = "Draft";
    }
  }

  getItemsList() {
    this.dataAccess
      .getJSONPost(
        "get_items_simple_list",
        [],
        [
          { k: "p_module", v: "orderlines" },
          { k: "p_supplier_id", v: this.supplierId },
          { k: "p_customer_id", v: this.customerId },
          { k: "p_currency_id", v: this.currencyId },
        ]
      )
      .then((data) => {
        this.items = Array.isArray(data) ? data : [];
        this.getWorkingDatesForItem();
      });
  }

  selectFile(event): void {
    this.uploadFile(event.target.files);
    event.srcElement.value = null;
  }

  uploadFile(files: FileList) {
    if (files.length == 0) {
      return;
    }

    const file: File = files[0];

    const uploadURL = this.dataAccess.getXLSUploadUrl("import_orders", [], []);
    this.upload.uploadFile(uploadURL, file).subscribe(
      (event) => {
        if (event instanceof HttpResponse) {
          if (!((event.body as any).res == 0)) {
            //Swal.fire("Error!", (event.body as any).msg, 'error');
            const uploadId = (event.body as any).reference;
            Swal.fire({
              title: "Error!",
              html: (event.body as any).msg,
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Download failed",
              showCancelButton: true,
            }).then((result) => {
              if (result.value) {
                this.exportFailedRows(uploadId);
              }
            });
            this.refreshList();
          } else {
            Swal.fire("Import complete!", (event.body as any).msg, "success");
            this.refreshList();
          }
        }
      },
      (err) => {
        Swal.fire("Error!", "Upload Error: " + err.statusText, "error");
      },
      () => {}
    );
  }

  export(): void {
    window.open(
      this.dataAccess.getXLSUrlNoJSON(
        "export_order_lines",
        [],
        [{ k: "p_order_id", v: this.id }],
        "order_lines"
      ),
      "_blank",
      "location=yes"
    );
  }

  exportFailedRows(uploadId: number): void {
    window.open(
      this.dataAccess.getXLSUrl(
        "export_failed_rows",
        [],
        [{ k: "p_upload_id", v: uploadId }],
        "failed_to_upload"
      ),
      "_blank",
      "location=yes"
    );
  }

  showSelectFileDialog(): void {
    document.getElementById("fileUpload").click();
  }

  openEditDialog(obj: any = null): void {
    if (obj) {
      this.line = obj;
    } else {
      this.line = this.selection.selected[0];
    }

    this.getGAForItem();
    this.showLinePanel = true;
  }

  openProceedDialog(operation = "proceed"): void {
    const tmpData: IOrder[] = [];
    let isInvalidSelection = false;
    let status = "";

    if (operation == "split") {
      if (
        this.selection.selected[0].status != "NW" &&
        this.selection.selected[0].status != "CF"
      ) {
        Swal.fire(
          "Error!",
          "You can split lines only in statuses: NW, CF",
          "error"
        );
        return;
      }
    }

    if (this.selection.selected[0].status == "UL") {
      Swal.fire("Error!", "You can not proceed unloaded lines", "error");
      return;
    }

    for (const s of this.selection.selected) {
      if (status == "") status = s.status;
      if (status != s.status) isInvalidSelection = true;
      tmpData.push(s);
    }

    if (isInvalidSelection) {
      Swal.fire(
        "Error!",
        "Selected lines should be in the same status",
        "error"
      );
    } else {
      const dialogRef = this.dialog.open(ProceedDialog, {
        data: {
          lines: tmpData,
          operation: operation,
        },
      });

      dialogRef.afterClosed().subscribe(() => {
        this.refreshList();
      });
    }
  }

  addNewLine() {
    this.line = {} as IOrder;
    this.line.line_type = "N";
    this.showLinePanel = true;
  }

  line_save() {
    //this.line = {} as IOrder;
    //this.showLinePanel = false;

    if (
      (this.origPickerValue &&
        !this.dataAccess.isValid(this.origPickerValue, "date")) ||
      (this.updPickerValue &&
        !this.dataAccess.isValid(this.updPickerValue, "date")) ||
      (this.confPickerValue &&
        !this.dataAccess.isValid(this.confPickerValue, "date"))
    ) {
      Swal.fire("Error!", "Incorrect date format.", "error");
      return;
    }

    if (
      this.line.original_qty != null &&
      this.line.original_qty.toString() != "" &&
      !/^\d+([\.\,]\d+)?$/.test(this.line.original_qty.toString())
    ) {
      Swal.fire("Error!", "Incorrect original qty format.", "error");
      return;
    }

    if (
      this.line.actual_price_for_payment != null &&
      this.line.actual_price_for_payment.toString() != "" &&
      !/^\d+([\.\,]\d+)?$/.test(this.line.actual_price_for_payment.toString())
    ) {
      Swal.fire("Error!", "Incorrect price format.", "error");
      return;
    }

    // if (this.line.original_date < this.minDate) {
    //   console.log(this.line.original_date)
    //   console.log(this.minDate)
    //   Swal.fire("Error!", 'Original date is too early.', 'error');
    //   return;
    // }

    this.dataAccess
      .getJSONPost(
        "save_order_line",
        [],
        [
          { k: "p_id", v: this.line.line_id },
          { k: "p_order_id", v: this.id },
          { k: "p_item_id", v: this.line.item_id },
          { k: "p_line_type", v: this.line.line_type },
          { k: "p_original_qty", v: this.formatDouble(this.line.original_qty) },
          {
            k: "p_original_date",
            v: this.dataAccess.parseDate(this.line.original_date),
          },
          {
            k: "p_updated_original_date",
            v: this.dataAccess.parseDate(this.line.updated_original_date),
          },
          {
            k: "p_confirmed_date",
            v: this.dataAccess.parseDate(this.line.confirmed_date),
          },
          { k: "p_ga_price", v: this.line.ga_price },
          { k: "p_ga_incoterm", v: this.line.ga_incoterm },
          {
            k: "p_actual_price_for_payment",
            v: this.formatDouble(this.line.actual_price_for_payment),
          },
          {
            k: "p_incoterm_for_actual_price",
            v: this.line.incoterm_for_actual_price,
          },
          { k: "p_customers_comments", v: this.line.customers_comments },
        ]
      )
      .then((data) => {
        if (data.res != 0) {
          Swal.fire("Error!", data.msg, "error");
        } else {
          this.line = {} as IOrder;
          this.showLinePanel = false;
          this.refreshList();
        }
      });
  }

  line_cancel() {
    this.line = {} as IOrder;
    this.showLinePanel = false;
    this.refreshList();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // selection of all the rows on the current page
  getPageData() {
    return this.dataSource._pageData(
      this.dataSource._orderData(this.dataSource.filteredData)
    );
  }

  isEntirePageSelected() {
    return this.getPageData().every((row) => this.selection.isSelected(row));
  }

  masterToggle(checkboxChange: MatCheckboxChange) {
    this.isEntirePageSelected()
      ? this.selection.deselect(...this.getPageData())
      : this.selection.select(...this.getPageData());
  }

  onSaveClick() {
    this.dataAccess
      .getJSONPost(
        "save_order",
        [],
        [
          { k: "p_id", v: this.id },
          { k: "p_order_no", v: this.orderNo },
          { k: "p_supplier_id", v: this.supplierId },
          { k: "p_customer_id", v: this.customerId },
          { k: "p_actual_currency_for_payment", v: this.currencyId },
        ]
      )
      .then((data) => {
        if (data.res != 0) {
          Swal.fire("Error!", data.msg, "error");
        } else {
          this.getItemsList();
          this.getWorkingDates();

          if (data.order_id) {
            this.id = data.order_id;
            this.allowEdit = false;
            this.addNewLine();
          }
          Swal.fire({
            icon: "success",
            title: "Order saved!",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  }

  checkRow(row) {
    if (this.selection.isSelected(row)) {
      this.selection.deselect(row);
    } else {
      this.selection.select(row);
    }
  }

  supplierChanged(supplierId: number) {
    this.supplierId = supplierId;
    //this.getItemsList();
  }

  lineTypeChange() {
    this.getWorkingDatesForItem();
  }

  itemChanged() {
    this.getWorkingDatesForItem();
    this.getGAForItem();
  }

  getWorkingDatesForItem() {
    if (this.line.line_type === undefined)
      return;
    const itemLeadTime = this.line.line_type === 'S' ? 7 : this.items.find(item => item.id == this.line.item_id)?.lead_time; // 7 day lead time for sample order
    if (itemLeadTime === undefined)
      return;
    this.workingDatesForItem = this.workingDatesData
      .filter(work_day => work_day.prod_day < itemLeadTime || !work_day.delivery_ok)
      .reduce(
        (result, work_day) => {
          result[work_day.date] = work_day.date;
          return result;
        },
        {}
      )
    ;
  }

  qtyChanged(e) {
    if (this.line.ga_price && this.line.original_qty) {
      this.line.original_value = +(
        this.line.ga_price * this.formatDouble(this.line.original_qty)
      ).toFixed(2);
    }
  }

  formatDouble(value: any) {
    return value ? parseFloat(value.toString().replace(",", ".")) : null;
  }

  origDateChanged(val: MatDatepickerInputEvent<any>) {
    this.origPickerValue = (val.targetElement as any).value;
    this.getGAForItem();
  }

  updDateChanged(val: MatDatepickerInputEvent<any>) {
    this.updPickerValue = (val.targetElement as any).value;
  }

  confDateChanged(val: MatDatepickerInputEvent<any>) {
    this.confPickerValue = (val.targetElement as any).value;
  }

  getGAForItem() {
    if (this.line.item_id && this.line.original_date) {
      this.dataAccess
        .getJSONPost(
          "get_ga_for_item",
          [],
          [
            { k: "p_supplier_id", v: this.supplierId },
            { k: "p_item_id", v: this.line.item_id },
            { k: "p_currency_id", v: this.currencyId },
            { k: "p_ga_incoterm", v: this.line.ga_incoterm },
            {
              k: "p_original_date",
              v: this.dataAccess.parseDate(this.line.original_date),
            },
          ]
        )
        .then((data) => {
          this.prices = Array.isArray(data) ? data : [];

          if (this.prices.length == 1) {
            this.line.ga_price_id = data[0].id;
            this.line.ga_price = data[0].ga_price;
            this.line.ga_incoterm = data[0].ga_incoterm;
            this.line.original_value = +(
              data[0].ga_price * this.formatDouble(this.line.original_qty)
            ).toFixed(2);
            if (!this.line.actual_currency_for_payment) {
              this.line.actual_price_for_payment = data[0].ga_price;
            }
            this.line.incoterm_for_actual_price = data[0].ga_incoterm;
          } else {
            if (
              this.prices.filter((x) => x.id == this.line.ga_price_id).length ==
              0
            ) {
              this.line.ga_price_id = null;
              this.line.ga_price = null;
              this.line.ga_incoterm = null;
              this.line.original_value = null;
              this.line.actual_price_for_payment = null;
              this.line.incoterm_for_actual_price = null;
            }
          }
        });
    }
  }

  priceChanged(e) {
    this.line.ga_price = this.prices.filter(
      (x) => x.id == this.line.ga_price_id
    )[0].ga_price;
    this.line.ga_incoterm = this.prices.filter(
      (x) => x.id == this.line.ga_price_id
    )[0].ga_incoterm;
    this.line.incoterm_for_actual_price = this.prices.filter(
      (x) => x.id == this.line.ga_price_id
    )[0].ga_incoterm;
    this.line.actual_price_for_payment = this.line.ga_price;
    if (this.line.ga_price && this.line.original_qty) {
      this.line.original_value = +(
        this.line.ga_price * this.formatDouble(this.line.original_qty)
      ).toFixed(2);
    }
  }

  public disableProceedButton() {
    return (
      this.selection.selected.length == 0 ||
      this.selection.selected
        .map((x) => x.status == this.selection.selected[0].status)
        .includes(false) ||
      (!this.isSupplier && !this.isCustomer) ||
      (this.isSupplier &&
        !["NW", "CF"].includes(this.selection.selected[0].status)) ||
      (this.isCustomer &&
        !["CR", "DP"].includes(this.selection.selected[0].status))
    );
  }

  public disableCancelButton() {
    if (
      this.selection.selected.length > 0 &&
      !this.selection.selected[0].status
    )
      return false;

    return (
      this.selection.selected.length == 0 ||
      this.selection.selected
        .map((x) => x.status == this.selection.selected[0].status)
        .includes(false) ||
      (!this.isSupplier && !this.isCustomer) ||
      (this.isCustomer &&
        !["CR", "NW"].includes(this.selection.selected[0].status)) ||
      (this.isSupplier &&
        !["NW", "CF"].includes(this.selection.selected[0].status))
    );
  }

  public disableSplitButton() {
    return (
      this.isCustomer ||
      this.selection.selected.length != 1 ||
      (this.selection.selected[0].status != "NW" &&
        this.selection.selected[0].status != "CF")
    );
  }

  enableEdit(param: IOrder = null) {
    let obj: IOrder;

    if (param) obj = param;
    else obj = this.selection.selected[0];

    return (
      (this.selection.selected.length == 1 || param) &&
      ((this.isSPUser && ["CF", "DP", "UL", "CC"].includes(obj.status)) ||
        (this.isSupplier && ["CF"].includes(obj.status)) ||
        (this.isCustomer && ["CR", "NW", "CF"].includes(obj.status)))
    );
  }

  getWorkingDates() {
    // console.log('getWorkingDates', this.line, this.line?.status);
    this.dataAccess
      .getJSONPost(
        "get_working_dates",
        [],
        [{ k: "p_supplier_id", v: this.supplierId }]
      )
      .then((data) => {
        this.workingDatesData = Array.isArray(data) ? data : [];
        this.getWorkingDatesForItem();
      });
  }

  onDisableDates = (date: any) => {
    if (!date)
      return false;
    const dateStr = this.datePipe.transform(date, 'yyyy-MM-dd');
    const isSuppAndCF = this.line.status && (this.line.status == 'CF' && this.isSupplier); // BUG_159987: when SUP edits CF order line put no limit on date to choose (other than no-delivery, but ignore LT)
    const okDates = isSuppAndCF ? this.disabledDates : this.workingDatesForItem;
    return !okDates[dateStr];
  };
}
